import { Link } from "react-router-dom";
import { useT } from "../hooks/useT";

export default function RiskPage() {
  const t = useT();
  return (
    <div className="min-h-screen bg-[var(--bg-default)]">
      <div className="max-w-[680px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <Link to="/" data-testid="risk-back-link" className="inline-block font-sans text-[11px] uppercase tracking-[0.15em] text-[var(--text-tertiary)] transition-colors duration-150 hover:text-[var(--text-secondary)] mb-16">
          &larr; {t.legal.back}
        </Link>
        <h1 className="font-serif text-3xl sm:text-4xl tracking-[0.04em] text-[var(--text-primary)] mb-3" style={{ fontWeight: 300 }}>{t.riskPage.heading}</h1>
        <p className="font-sans text-[12px] text-[var(--text-tertiary)] mb-16">{t.legal.updated}</p>
        <div className="space-y-10">
          {t.riskPage.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-serif text-lg text-[var(--text-primary)] mb-3" style={{ fontWeight: 400 }}>{s.title}</h2>
              <p className="font-sans text-[15px] text-[var(--text-secondary)] leading-[1.75]">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
